import React, { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Box } from 'roo-ui/components';
import Waypoint from './Waypoint';
import { emitScrollTracking } from 'store/userEnvironment/userEnvironmentActions';

const DEFAULT_WAYPOINTS = [
  { waypointId: 1, active: false },
  { waypointId: 2, active: false },
  { waypointId: 3, active: false },
  { waypointId: 4, active: false },
];

const Waypoints = () => {
  const [waypointsList, setWaypointsList] = useState(DEFAULT_WAYPOINTS);
  const dispatch = useDispatch();

  const activateWaypoint = useCallback(
    (updatedWaypoint) => {
      const updatedWaypointsList = waypointsList.map((waypoint) =>
        waypoint.waypointId === updatedWaypoint.waypointId ? updatedWaypoint : waypoint,
      );
      setWaypointsList(updatedWaypointsList);
      dispatch(emitScrollTracking({ pixels: updatedWaypoint.pixelOffset, distance: `${updatedWaypoint.waypointId * 25}%` }));
    },
    [waypointsList, dispatch],
  );

  return (
    <Box data-testid="waypoint-list">
      {waypointsList.map(
        ({ waypointId, active }) =>
          !active && <Waypoint key={`waypoint-${waypointId}`} waypointId={waypointId} onViewed={activateWaypoint} />,
      )}
    </Box>
  );
};

export default Waypoints;
